/**
 * Recommendations — service providers service
 *
 * Fetches service providers recommended to the current user based on their
 * location and activity.
 *
 * Endpoint: GET /api/recommendations/service_providers
 *
 * Errors:
 *   401 — unauthenticated
 *   422 "user_has_no_location" — user has no location set
 */
import { createApiWithNewBasePath as api } from "@api";
import { IRecommendedServiceProvidersResponse } from "../types/recommendations.types";

export const API_PATH = "recommendations/service_providers";

export const getRecommendedServiceProviders = () =>
  api.get<undefined, IRecommendedServiceProvidersResponse>(API_PATH);
